
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-intermediate-connection-point-demo-connection-point-multi"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.en.md?type=demo')
};